<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'OFWCA'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group >
  <mat-tab label="Dane">
  <app-hiperio-registration-config-details-view  (modifyClicked)="loadHiperioRegistrationConfig()" [hiperioRegistrationConfig]="hiperioRegistrationConfig" > </app-hiperio-registration-config-details-view>
  </mat-tab>x
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list  [hiperioRegistrationConfig]="hiperioRegistrationConfig"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
